import React from 'react'

import './index.scss'

export const PlusIcon: React.FC = () => (
  <svg
    className="icon icon--plus"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="stroke"
      d="M5.33333 9.99998H14.6667M9.99999 5.33331V14.6666"
      strokeLinecap="square"
    />
  </svg>
)
